<template>
  <va-edit-layout>
    <testimonies-form :id="id" :title="title" :item="item"></testimonies-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
